import axios from 'axios';

const API_URL = '/api';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// 聊天消息API
export const chatMessageApi = {
  // 获取消息列表
  getMessages: async (page = 1, pageSize = 50) => {
    const response = await axios.get(`${API_URL}/chat-admin/messages`, {
      headers: getAuthHeader(),
      params: { page, pageSize }
    });
    return response.data;
  },

  // 发送消息
  sendMessage: async (content: string) => {
    const response = await axios.post(
      `${API_URL}/chat-messages`,
      { content },
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // 删除消息
  deleteMessage: async (id: number) => {
    const response = await axios.delete(`${API_URL}/chat-admin/messages/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // 批量删除消息
  batchDeleteMessages: async (ids: number[]) => {
    const response = await axios.post(
      `${API_URL}/chat-admin/messages/batch-delete`,
      { ids },
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // 获取在线用户
  getOnlineUsers: async () => {
    const response = await axios.get(`${API_URL}/chat-messages/chat-online-users`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // 更新在线状态
  updateOnlineStatus: async () => {
    const response = await axios.post(
      `${API_URL}/chat-messages/chat-online-status`,
      {},
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // 获取聊天室统计
  getStats: async () => {
    const response = await axios.get(`${API_URL}/chat-admin/stats`, {
      headers: getAuthHeader()
    });
    return response.data;
  }
};

// 聊天敏感词API
export const chatBannedWordApi = {
  // 获取敏感词列表
  getBannedWords: async (page = 1, pageSize = 50) => {
    const response = await axios.get(`${API_URL}/chat-admin/banned-words`, {
      headers: getAuthHeader(),
      params: { page, pageSize }
    });
    return response.data;
  },

  // 添加敏感词
  addBannedWord: async (word: string) => {
    const response = await axios.post(
      `${API_URL}/chat-admin/banned-words`,
      { word },
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // 删除敏感词
  deleteBannedWord: async (id: number) => {
    const response = await axios.delete(`${API_URL}/chat-admin/banned-words/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  }
};

// 禁言管理API
export const chatMuteApi = {
  // 获取禁言列表
  getMutedUsers: async (page = 1, pageSize = 50) => {
    const response = await axios.get(`${API_URL}/chat-admin/mutes`, {
      headers: getAuthHeader(),
      params: { page, pageSize }
    });
    return response.data;
  },

  // 禁言用户
  muteUser: async (data: {
    user_id: number;
    username: string;
    reason?: string;
    mute_type?: 'temp' | 'permanent';
    duration_minutes?: number;
  }) => {
    const response = await axios.post(
      `${API_URL}/chat-admin/mutes`,
      data,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // 解除禁言
  unmuteUser: async (user_id: number) => {
    const response = await axios.delete(`${API_URL}/chat-admin/mutes`, {
      headers: getAuthHeader(),
      data: { user_id }
    });
    return response.data;
  },

  // 检查禁言状态
  checkMuteStatus: async (user_id: number) => {
    const response = await axios.get(`${API_URL}/chat-admin/mutes/check`, {
      headers: getAuthHeader(),
      params: { user_id }
    });
    return response.data;
  }
};

// 发言频率API
export const chatRateLimitApi = {
  // 获取频率限制设置
  getSettings: async () => {
    const response = await axios.get(`${API_URL}/chat-admin/rate-limit/settings`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // 检查频率限制
  checkRateLimit: async (user_id: number) => {
    const response = await axios.get(`${API_URL}/chat-admin/rate-limit/check`, {
      headers: getAuthHeader(),
      params: { user_id }
    });
    return response.data;
  },

  // 重置用户统计
  resetUserStats: async (user_id: number) => {
    const response = await axios.post(
      `${API_URL}/chat-admin/rate-limit/reset`,
      { user_id },
      { headers: getAuthHeader() }
    );
    return response.data;
  }
};
